import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createIntl } from 'react-intl-next';
import { date } from '@atlaskit/adf-schema';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { timestampToString } from '@atlaskit/editor-common/utils';
import { ZERO_WIDTH_SPACE } from '@atlaskit/editor-common/whitespace';
import { N30A, N800 } from '@atlaskit/theme/colors';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { getDateInformation } from './utils';
var isSSR = Boolean(process.env.REACT_SSR);
var intlRef;

/**
 * Wrapper for ADF date node spec to augment toDOM implementation
 * with fallback UI for lazy node view rendering / window virtualization
 * @nodeSpecException:toDOM patch
 * @returns
 */
export var dateNodeSpec = function dateNodeSpec() {
  if (!editorExperiment('platform_editor_vanilla_dom', true) && (isSSR || editorExperiment('platform_editor_inline_node_virtualization', 'off'))) {
    return date;
  }
  return _objectSpread(_objectSpread({}, date), {}, {
    toDOM: dateToDOMvirtualization
  });
};
export var dateToDOMvirtualization = function dateToDOMvirtualization(node) {
  intlRef = intlRef || createIntl({
    locale: document.documentElement.lang || 'en-US'
  });
  var timestamp = node.attrs.timestamp;
  var displayString = timestampToString(timestamp, intlRef);
  var wrapperAttrs = {
    class: 'date-lozenger-container',
    'data-node-type': 'date',
    'data-timestamp': timestamp,
    'aria-busy': 'true'
  };
  var attrs = {
    style: convertToInlineCss({
      // Taken from @atlaskit/date Component
      backgroundColor: "var(--ds-background-neutral, ".concat(N30A, ")"),
      color: "var(--ds-text, ".concat(N800, ")"),
      borderRadius: "var(--ds-border-radius-100, 4px)",
      padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
      margin: '0 1px'
    })
  };
  return ['span', wrapperAttrs, ['span', attrs, displayString]];
};
export var dateToDOM = function dateToDOM(node, state, getPos, intl) {
  var timestamp = node.attrs.timestamp;
  var pos = getPos === null || getPos === void 0 ? void 0 : getPos();
  var _getDateInformation = getDateInformation(timestamp, intl, state, pos),
    displayString = _getDateInformation.displayString,
    color = _getDateInformation.color;
  var nodeWrapperAttrs = {
    contenteditable: 'false',
    timestamp: timestamp,
    class: 'dateView-content-wrap inlineNodeView',
    'data-prosemirror-content-type': 'node',
    'data-prosemirror-node-name': 'date',
    'data-prosemirror-node-inline': 'true',
    'data-prosemirror-node-view-type': 'vanilla',
    draggable: 'true'
  };
  var wrapperAttrs = {
    class: 'date-lozenger-container',
    'data-node-type': 'date',
    'data-timestamp': timestamp
  };
  var attrs = color === undefined ? {} : {
    class: "date-node-color-".concat(color)
  };
  return ['span', nodeWrapperAttrs, ['span', {
    class: 'zeroWidthSpaceContainer'
  }, ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, ZERO_WIDTH_SPACE]], ['span', wrapperAttrs, ['span', attrs, displayString]], ['span', {
    class: 'inlineNodeViewAddZeroWidthSpace'
  }, ZERO_WIDTH_SPACE]];
};